import { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import dayjs from 'dayjs'
import { Link } from '@src/components/Link'
import { orderCenterRoutes } from '@src/routes'
import { sendEvent } from '@src/utils/analytics/coreAnalytics'
import { GTMEventTypes } from '@sial/common-utils'

const useStyles = makeStyles((theme: Theme) => {
  return {
    item: {
      padding: theme.spacing(3, 5),
      borderBottom: `1px solid ${theme.palette.grey['400']}`,
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
        cursor: 'pointer',
      },
    },
    title: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
    },
    content: {
      display: 'flex',
      fontSize: theme.typography.pxToRem(16),
      justifyContent: 'space-between',
      alignItems: 'baseline',
    },
    date: {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.grey[800],
    },
  }
})

const renderNotificationTypeLabel = (notificationType: string) => {
  if (notificationType === 'SHIPPED') {
    return <FormattedMessage id="SHIPPED_ITEM" defaultMessage="Shipped Item" />
  } else {
    return notificationType
  }
}

const NotificationContainer = ({
  orderNumber,
  notificationType,
  eventDate,
}: {
  orderNumber: string
  notificationType: string
  eventDate: number
}) => {
  const classes = useStyles()

  const handleClick = () => {
    sendEvent({
      eventType: GTMEventTypes.AnalyticsEvent,
      payload: {
        event: 'notification_interaction',
        action: 'select notification',
        detail: `${renderNotificationTypeLabel(notificationType)} > ${orderNumber}`,
        section: 'notifications',
        component: 'NotificationItem',
        element_type: 'href',
        element_text: `${renderNotificationTypeLabel(notificationType)} > ${orderNumber} ${dayjs(eventDate).format('MMM D')}`,
        link_url: orderCenterRoutes.orderDetail(orderNumber),
        core_event: 'no',
        user_detail: undefined,
        event_group: undefined,
        event_subgroup: undefined,
      },
    })
  }

  return (
    <Link
      href={orderCenterRoutes.orderDetail(orderNumber)}
      onClick={handleClick}
    >
      <div className={classes.item}>
        <h4 className={classes.title}>
          {renderNotificationTypeLabel(notificationType)}
        </h4>
        <div className={classes.content}>
          <span>Order: {orderNumber}</span>
          <span className={classes.date}>
            {dayjs(eventDate).format('MMM D')}
          </span>
        </div>
      </div>
    </Link>
  )
}

export default NotificationContainer
